import React from "react";
import { ArrowUp } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const quickLinks = [
    { id: "home", key: "nav.home" },
    { id: "principles", key: "nav.principles" },
    { id: "definitions", key: "nav.definitions" },
    { id: "reporting", key: "nav.reporting" },
    { id: "conduct", key: "nav.conduct" },
  ];

  const contentLinks = [
    { id: "intro", key: "nav.intro" },
    { id: "principles", key: "nav.principles" },
    { id: "definitions", key: "nav.definitions" },
    { id: "reporting", key: "nav.reporting" },
    { id: "conduct", key: "nav.conduct" },
    { id: "training", key: "nav.training" },
  ];

  return (
    <footer className="bg-[#1a1a2e] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="mb-4">
              <span className="text-lg font-bold">{t("siteConfig.siteName")}</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">{t("footer.description")}</p>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.quickLinks")}</h4>
            <div className="space-y-2">
              {quickLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-gray-400 text-sm hover:text-[#E8792B] transition-colors"
                >
                  {t(link.key)}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.policyContents")}</h4>
            <div className="space-y-2">
              {contentLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-gray-400 text-sm hover:text-[#E8792B] transition-colors"
                >
                  {t(link.key)}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">{t("footer.copyright")}</p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-gray-400 hover:text-[#E8792B] transition-colors text-sm"
          >
            <span>{t("footer.backToTop")}</span>
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
